import { v4 as uuidv4 } from "uuid";
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Dynamic Yield SDK has no TypeScript declarations
let DY;
// for Jest
try {
    DY = window.DY;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty
}
catch (ex) {
}
export function isValidDynamicYieldProductPage() {
    try {
        return (!!DY &&
            !!DY.recommendationContext &&
            !!DY.recommendationContext.data &&
            DY.recommendationContext.data.length > 0 &&
            DY.recommendationContext.type === "PRODUCT");
    }
    catch (_a) {
        return false;
    }
}
export function sendDYEvents(category, transactionId = uuidv4()) {
    if (!!DY && !!category) {
        DY.API("event", {
            name: category,
            properties: {
                lead: category,
            },
        });
    }
    if (!isValidDynamicYieldProductPage()) {
        return;
    }
    DY.API("event", {
        name: "Add to Cart", // Common name, not used to identify the event type
        properties: {
            dyType: "add-to-cart-v1", // Do Not Change
            productId: DY.recommendationContext.data[0],
            value: 1.0, // as we discussed we are putting value 1 for all leads
            quantity: 1,
            cart: [
                {
                    productId: DY.recommendationContext.data[0], // SKU exactly as in the product feed
                    itemPrice: 1.0, //Must be a float
                    quantity: 1,
                },
            ],
        },
    });
    DY.API("event", {
        name: "Purchase", // Common name, not used to identify the event type
        properties: {
            uniqueTransactionId: transactionId, // Removes redundant events, Max 64 characters
            dyType: "purchase-v1", // Identifies this event as a purchase. Do Not Change.
            value: 1.0, // Total cart value
            cart: [
                {
                    productId: DY.recommendationContext.data[0], // SKU exactly as in the product feed
                    itemPrice: 1.0, // Must be a float
                    quantity: 1,
                },
            ],
        },
    });
}
